import styles from "./HeroPage.module.scss";
import Header from "../../components/header/Header";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../constants/routes";
import { useState } from "react";
import useWindowSize from "../../hooks/useWindowSize";
import LogoIcon from "../../components/icons/Logo";
import swipeIcon from "./assets/swipe.svg";
import likeIcon from "./assets/like.svg";
import shareIcon from "./assets/share.svg";

const HeroPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { windowSize } = useWindowSize();
  const [activeFeature, setActiveFeature] = useState<number | null>(null);
  const isMobile = windowSize === "mobile";

  const startHandler = () => {
    localStorage.setItem("heroSeen", "1");
    navigate(ROUTES.FOR_YOU);
  };

  const features = [
    {
      label: t("hero_swipe"),
      desc: t("hero_swipe_desc"),
      icon: swipeIcon,
      iconClassName: styles.swipeIcon,
      baseClassName: styles.swipeBase,
      accentClassName: styles.swipeAccent,
    },
    {
      label: t("hero_save"),
      desc: t("hero_save_desc"),
      icon: likeIcon,
      iconClassName: styles.saveIcon,
      baseClassName: styles.saveBase,
      accentClassName: styles.saveAccent,
    },
    {
      label: t("hero_share"),
      desc: t("hero_share_desc"),
      icon: shareIcon,
      iconClassName: styles.shareIcon,
      baseClassName: styles.shareBase,
      accentClassName: styles.shareAccent,
    },
  ];

  return (
    <div className={styles.wrapper}>
      <Header source="hero" className={styles.header} />

      <div className={styles.content}>
        <div className={styles.logo}>
          <LogoIcon width={130} height={29} />
        </div>

        <h1 className={styles.title}>{t("hero_title")}</h1>

        <div className={styles.features}>
          {features.map((f, i) => (
            <div
              key={i}
              className={`${styles.featureItem} ${activeFeature === i ? styles.featureItemActive : ""}`}
              {...(isMobile
                ? { onClick: () => setActiveFeature(activeFeature === i ? null : i) }
                : { onMouseEnter: () => setActiveFeature(i), onMouseLeave: () => setActiveFeature(null) })}
            >
              <div className={styles.iconWrapper}>
                <div className={styles.iconInner}>
                  <img src={f.icon} alt="" className={`${styles.iconLayer} ${styles.iconBase} ${f.iconClassName} ${f.baseClassName}`} />
                  <img src={f.icon} alt="" className={`${styles.iconLayer} ${styles.iconAccent} ${f.iconClassName} ${f.accentClassName}`} />
                </div>
              </div>
              <span className={styles.featureLabel}>{f.label}</span>
            </div>
          ))}
        </div>

        <p className={styles.subtitle}>{activeFeature !== null ? features[activeFeature].desc : t("hero_swipe_desc")}</p>

        <button className={styles.cta} onClick={startHandler}>
          {t("hero_cta")}
        </button>
      </div>
    </div>
  );
};

export default HeroPage;
